import { render, staticRenderFns } from "./userIntention.vue?vue&type=template&id=0973614a&scoped=true"
import script from "./userIntention.vue?vue&type=script&lang=js"
export * from "./userIntention.vue?vue&type=script&lang=js"
import style0 from "./userIntention.vue?vue&type=style&index=0&id=0973614a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0973614a",
  null
  
)

export default component.exports